import React, { FC } from 'react';

import { getContentState } from '../../utilities';

const LinkDecorator: FC<any> = ({ children, entityKey, getEditorState }) => {
  const entity = getContentState(getEditorState()).getEntity(entityKey);
  const entityData = entity && entity.getData();

  if (!entityData) {
    return null;
  }

  const { url } = entityData;

  return (
    <a title={url} href={url} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
};

export default LinkDecorator;
